import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { ObjectDetectionInsightsDialogContent } from "./ObjectDetectionInsightsDialogContent";
import { reIdThunks } from "./store/slice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { reIdSelectors } from "./store/selectors";
import { ObjectDetectionFrame } from "types/reId/ObjectDetectionFrame";
import { EntityId } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";

export interface ObjectDetectionInsightsDialogProps {
    closeDialog: () => void;
    dossierId: EntityId;
    selectedObjectDetectionFrame: ObjectDetectionFrame;
}

export function ObjectDetectionInsightsDialog(
    props: ObjectDetectionInsightsDialogProps,
) {
    const dispatch = useAppDispatch();

    const activePersistedRecordingToPlay = useAppSelector(
        reIdSelectors.selectActiveVectorSearchResultRecordToPlay,
    );

    const selectedModelName = useAppSelector(
        reIdSelectors.selectSelectedObjectDetectionModelName,
    );

    const [vectorSearchDistance, setVectorSearchDistance] =
        useState<number>(0.1);

    useEffect(() => {
        if (selectedModelName) {
            dispatch(
                reIdThunks.reIdFetchPersistedRecordingsForActiveDetectedObjectIdAsync(
                    {
                        dossierId: props.dossierId,
                        selectedDetectedObjectFrame:
                            props.selectedObjectDetectionFrame,
                        maxDistance: vectorSearchDistance,
                        objectDetectionModelName: selectedModelName,
                    },
                ),
            );
        }
    }, [
        props.selectedObjectDetectionFrame,
        vectorSearchDistance,
        selectedModelName,
    ]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={"xl"}
            slotProps={{
                paper: {
                    sx: {
                        width: "min(1280px, 95vw)",
                        height: "min(820px, 90vh)",
                        maxWidth: "none",
                    },
                },
            }}
        >
            <DialogTitle>Detected Object Insights</DialogTitle>
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    p: 0,
                }}
            >
                <ObjectDetectionInsightsDialogContent
                    defaultVectorSearchDistance={vectorSearchDistance}
                    onVectorSearchDistanceChanged={setVectorSearchDistance}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        // cancel dialog
                        props.closeDialog();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        dispatch(
                            reIdThunks.showDetectedObjectInLiveMode({
                                startTimeForTimeline:
                                    activePersistedRecordingToPlay?.persistedStartTimeWithFirstSeenTime as string,
                            }),
                        );

                        // cancel dialog
                        props.closeDialog();
                    }}
                >
                    Show this video in the main player
                </Button>
            </DialogActions>
        </Dialog>
    );
}
